import { Listbox } from '@headlessui/react';
import { ChevronUpDownIcon, CheckIcon } from '@heroicons/react/20/solid';
import { useSortBy } from 'react-instantsearch';

export function CustomSortBy({ items, onIndexChange }) {
    const { refine, currentRefinement } = useSortBy({
        items: items.map(item => ({
            label: item.label,
            value: item.value,
            // Algolia expects this format
            name: item.name || item.value
        }))
    });

    const currentOption = items.find(item => item.value === currentRefinement) || items[0];

    const handleChange = (selected) => {
        refine(selected.value);
        if (onIndexChange) {
            onIndexChange(selected.value);
        }
    };

    return (
        <div className="w-44 z-40">
            <Listbox value={currentOption} onChange={handleChange}>
                {({ open }) => (
                    <div className="relative">
                        <Listbox.Button className="relative w-full h-[38px] cursor-default rounded-md bg-white py-2 pl-3 pr-10 text-left text-gray-900 shadow-sm border border-gray-300 focus:outline-none focus:ring-2 focus:ring-sky-600 sm:text-sm sm:leading-6">
                            <span className="block truncate">
                                {currentOption.label}
                            </span>
                            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                <ChevronUpDownIcon className="h-5 w-5 text-gray-400"/>
                            </span>
                        </Listbox.Button>

                        <Listbox.Options className="absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {items.map((item) => (
                                <Listbox.Option
                                    key={item.value}
                                    value={item}
                                    className={({ active }) =>
                                        `relative cursor-default select-none py-2 pl-3 pr-9 text-left
                                        ${active ? 'bg-sky-600 text-white' : 'text-gray-900'}`
                                    }
                                >
                                    {({ selected, active }) => (
                                        <>
                                            <span className={`block truncate ${selected ? 'font-semibold' : 'font-normal'}`}>
                                                {item.label}
                                            </span>
                                            
                                            {selected ? (
                                                <span
                                                    className={`absolute inset-y-0 right-0 flex items-center pr-4 ${
                                                        active ? 'text-white' : 'text-sky-600'
                                                    }`}
                                                >
                                                    <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                </span>
                                            ) : null}
                                        </>
                                    )}
                                </Listbox.Option>
                            ))}
                        </Listbox.Options>
                    </div>
                )}
            </Listbox>
        </div>
    );
}